/*
  ============================================================
  RV PREORDER BLOCK — ATC + ACCORDION + CROSS-SELL JS
  ============================================================
  ADD INSIDE the existing <script> tag at the bottom of
  instant-eGMzjDAjx3AwSlJp-black-friday__5_.liquid

  WHY OWN ATC NEEDED:
  The preorder button uses id="rv-po-atc" — intentionally
  different from "rv-add-to-cart" — so rv-custom1.js
  updateATC() and the MutationObserver never touch it.

  Cart add uses /cart/add.js directly, then opens the drawer
  the same way rv-custom1.js does (cart-drawer-pull-rv click
  + cart:refresh event).

  COVERS:
  1. Reserve button → /cart/add.js → open cart drawer
  2. Accordion open/close toggle
  3. White Edition cross-sell navigation
  ============================================================
*/

(function () {
  'use strict';

  /* ─────────────────────────────────────────
     1. ATC BUTTON — /cart/add.js
     Rendered in BOTH states via Liquid.
       data-state="preorder" → preorder product + _preorder properties
       data-state="instock"  → current product, no extra properties
  ───────────────────────────────────────── */
  function rvInitAtc() {
    var btn = document.getElementById('rv-po-atc');
    if (!btn || btn.dataset.rvAtcReady === 'true') return;
    btn.dataset.rvAtcReady = 'true';

    var variantId = btn.getAttribute('data-variant-id');
    var state     = btn.getAttribute('data-state');
    if (!variantId) return;

    btn.addEventListener('click', function () {
      btn.disabled = true;
      btn.classList.add('rv-po-loading');

      var item = {
        id: parseInt(variantId, 10),
        quantity: 1
      };
      if (state === 'preorder') {
        item.properties = { _preorder: true, DeliveryType: 'Preorder' };
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        /* Open cart drawer — same methods rv-custom1.js uses */
        var drawerPull = document.querySelector('.cart-drawer-pull-rv');
        if (drawerPull) drawerPull.click();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function () {
        /* Fallback: direct cart page */
        window.location.href = '/cart/' + variantId + ':1';
      })
      .finally(function () {
        btn.disabled = false;
        btn.classList.remove('rv-po-loading');
      });
    });

    console.log('[RV ATC] ready — state:', state, 'variant:', variantId);
  }

  /* ─────────────────────────────────────────
     2. ACCORDION TOGGLE
  ───────────────────────────────────────── */
  function rvInitAccordions() {
    document.querySelectorAll('[data-rv-acc]').forEach(function (btn) {
      if (btn.dataset.rvAccReady === 'true') return;
      btn.dataset.rvAccReady = 'true';

      btn.addEventListener('click', function () {
        var itemId = btn.getAttribute('data-rv-acc');
        var item   = document.getElementById(itemId);
        var body   = document.getElementById(itemId + '-body');
        if (!item || !body) return;

        var isOpen = item.classList.contains('rv-po-acc-open');
        if (isOpen) {
          item.classList.remove('rv-po-acc-open');
          body.style.maxHeight = '0';
          body.style.opacity   = '0';
          body.style.overflow  = 'hidden';
          btn.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('rv-po-acc-open');
          body.style.overflow  = 'hidden';
          body.style.maxHeight = body.scrollHeight + 'px';
          body.style.opacity   = '1';
          btn.setAttribute('aria-expanded', 'true');
          setTimeout(function () {
            if (item.classList.contains('rv-po-acc-open')) body.style.maxHeight = '600px';
          }, 320);
        }
      });
    });
  }

  /* ─────────────────────────────────────────
     3. CROSS-SELL — now a plain <a href> in Liquid
        (rv_cross_sell_product.url resolved server-side),
        no JS needed for navigation.
  ───────────────────────────────────────── */

  /* ─────────────────────────────────────────
     BOOT
  ───────────────────────────────────────── */
  function rvBoot() {
    rvInitAtc();
    rvInitAccordions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rvBoot);
  } else {
    rvBoot();
  }

})();